import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';

const styles = () => ({
  root: {},
});

const sizeMap = {
  sm: 'body1',
  md: 'h6',
};

const TabSubLabel = ({
  className, classes, label, size,
}) => {
  return (
    <Box className={classNames(classes.root, className)}>
      <Typography
        className={classes.label}
        variant={sizeMap[size]}
        weight={'bold'}
        color={'primaryGray'}
        test={`tab-sub-label-${label}`}
      >
        {label}
      </Typography>
    </Box>
  );
};

TabSubLabel.defaultProps = {
  className: '',
  size: 'md',
};

TabSubLabel.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['sm', 'md']),
};

export default withStyles(styles)(TabSubLabel);
